import React, { Component } from "react";
import dataJSON from "../../static/api/data.json";
import Slider from "../Helpers/Slider/Slider";
import "./Miflagot.scss";
import PopupError from "../Popup/PopupError.jsx";
import { apiURL } from "../Services/Base.js";
import Loading from "../Services/Loading/Loading.jsx";
import { mobile } from "../Services/Agent.js";
import OwlCarousel from 'react-owl-carousel';

const InnerItem = props => {
    return (
        <div onClick={() => {
            props.setClick(props.index);
            props.setData(props);
        }}
            className={`item ${props.isActive ? " active" : ""} image-${props.image}`}>
            <div className="bluefade"></div>
            <div className="image">
                <div className="points-circle">
                    <div className="points">
                        {props.mandats}
                    </div>
                </div>
            </div>
            <div className="miflaga">{props.name}</div>
        </div>
    )
}

const MemberItem = props =>{
    return (
            // <div className="item">
            //     <img src = {props.imgPath} />
            // </div>
        <div className="member-item">
            <div className="bluefade">
                <img src = {props.imgPath} />
                <span>{props.name}</span>
            </div> 
        </div>
    )
}
export default class Miflagot extends Component {
    constructor() {
        super();
        this.state = {
            OwlRef: null,
            itemsClicked: {},
            items: {},
            data: [],
            dateUpdated: "",
            renderSlider: false
        }
    }
    componentDidMount() {
        window.setTimeout(() => {
            this.setClick(0);
            this.setClick(0);
        }, 150);
        this.getData(this.getPollsByParty);
        // window.addEventListener("resize", () => {
        //     this.setState({
        //         renderSlider: true
        //     }, () => {
        //         window.setTimeout(() => {
        //             this.setState({
        //                 renderSlider: false
        //             });
        //         }, 250);
        //     });
        // })
    }
    componentDidUpdate(prevProps) {
        if(prevProps.currentParty != this.props.currentParty )
        {
            this.setState({renderSlider: true });
        }

    }
    getData = (callback) => {
        fetch(`${apiURL}polls/Get_all`, {
            "Content-Type": "application/json"
        }).then(response => response.json()).then(data => {
            this.setState({
                data: data
            }, callback);
        }).catch(e => console.log(e));
    }
    getPollsByParty = () => {
        const { data } = this.state;
        let _data = [];

        if (data.filter(k => k.PollAuthor == 7).length == 0) {
            //all
            _data = data.sort((a, b) => {
                // return b.ID - a.ID;
                return new Date(b.PollDate) - new Date(a.PollDate);
            })[0];
        } else {
            // Only Manual (7) / Ulpan (6) / Yedioth ()
            _data = data.filter(k => k.PollAuthor == 7).sort((a, b) => {
                return new Date(b.PollDate) - new Date(a.PollDate);
            })[0];
        }


        let byParty = this.calCulatDateParties(_data);
        let proxyData = [];
        let startChair = 1;

        // dataJSON.map((item, index) => {
        //     let miflaga = byParty.filter(k => k.Miflaga == item.name);
        //     if (miflaga.length == 1) {
        //         proxyData.push({
        //             name: miflaga[0].Miflaga,
        //             image: item.image,
        //             mandats: miflaga[0].Mandat,
        //             englishName: item.englishName,
        //             startChair: startChair,
        //             endChair: startChair + miflaga[0].Mandat -1,
        //             members:item.members                   
        //         })
        //         //calculate first chair for the next party
        //         startChair += miflaga[0].Mandat;
        //     }
        // })

        // let sortedData = byParty.sort((a,b) => b.Mandat - a.Mandat)
        byParty.map((item, index) => {
            let miflaga = dataJSON.filter(k => k.name == item.Miflaga);
            if (miflaga.length == 1) {
                proxyData.push({
                    name: item.Miflaga,
                    image: miflaga[0].image,
                    mandats: item.Mandat,
                    englishName: miflaga[0].englishName,
                    startChair: startChair,
                    endChair: startChair + item.Mandat -1,
                    members:miflaga[0].members                   
                })
                //calculate first chair for the next party
                startChair += item.Mandat;
            }
        })

        // let realDate = _data[_data.length - 1].PollDate.split("T")[0].split("-");
        let realDate = _data.PollDate.split("T")[0].split("-");
        this.setState({
            dateUpdated: `${realDate[2]}.${realDate[1]}.${realDate[0]}`,
            data: proxyData
        })
        this.props.setPartiesData(proxyData);
    }
    calCulatDateParties = (data, isSummary = false) => {
        let parties = {}, partiesArray = [];
        // data.forEach(obj => {
        let _parties = data.PollMiflaga.filter(k => k.Mandat != null);
        _parties.map((item, index) => {
            parties = {
                ...parties,
                [item.Miflaga]: {
                    ...parties[item.Miflaga],
                    Miflaga: item.Miflaga,
                    Mandat: item.Mandat + (isSummary ? (parties[item.Miflaga] ? parties[item.Miflaga].Mandat : 0) : 0),
                    Times: 1 + (isSummary ? (parties[item.Miflaga] ? parties[item.Miflaga].Times : 0) : 0),
                }
            }
        });
        // })

        for (let key in parties) {
            partiesArray.push(parties[key])
        }
        return partiesArray;
    }
    setData = item => {
        let { items } = this.state;
        if (items[item.index] != null) {
            delete items[item.index];
        } else {
            items = {
                ...items,
                [item.index]: {
                    ...items[item.index],
                    Miflaga: item.name,
                    Mandats: items && items[item.index] ?
                        (items[item.index].Mandats == 0 ? item.mandats : 0) : item.mandats,
                    EnglishName: item.englishName
                }
            }
        }
        this.setState({
            items
        })
    }
    
    setClick = index => {
        let { itemsClicked } = this.state;
        itemsClicked = {
            ...itemsClicked,
            [index]: {
                isClicked: itemsClicked[index] ? (itemsClicked[index].isClicked ? false : true) : true
            }
        }
        this.setState({
            itemsClicked: itemsClicked
        }, () => {
            this.setState({
                renderSlider: true
            });
        })
    }
    setOwlRef = ref => {
        this.setState({
            OwlRef: ref
        })
    }
    renderMiflagot = () => {
        return this.state.data.sort((a, b) => b.mandats - a.mandats).map((item, index) => <InnerItem key={index} index={index}
            setClick={this.setClick}
            setData={this.setData}
            sendScore={this.props.setCounter}
            isActive={this.state.itemsClicked[index] && this.state.itemsClicked[index].isClicked == true}
            {...item} />);

    }
    renderKnessetMembersImgs = () => {
        let imgList = [];
        for (let i=0; i < this.props.currentParty.mandats ; i++){
            let currentMember = this.props.currentParty.members[i];
            if(currentMember != undefined){
                let filePath = "./Parties/" + this.props.currentParty.englishName + "/" + currentMember.imageName +".png";
                imgList.push(<MemberItem name={currentMember.name} imgPath={filePath} />)
            }
        }
        return imgList;
    }
    render() {
        return (
            <section className="section section-miflagot">
                <Loading showLoading={this.state.data.length == 0} />
                <div className="padding">
                    <div className="container">
                        {this.props.logoPath != "" ?
                        <div>
                            <picture className="logo">
                                <source srcset={this.props.darkLogoPath} media="(prefers-color-scheme: dark)"/>
                                <img src={this.props.logoPath} />
                            </picture>
                            <div className="slider">
                                <Slider
                                    renderSlider={this.state.renderSlider}
                                    items={6}
                                    setOwlRef={this.setOwlRef}>
                                    {this.renderKnessetMembersImgs()}
                                </Slider>
                            </div>
                        </div>: 
                        <div className="remarks">                            
                            <div className="first"></div>
                            <div className="second">
                                <span className="chair">לחצו על הכיסאות</span>
                                <span>וגלו מי צפויים להיות הח"כים הבאים</span>
                            </div>
                        </div>}                        
                        {/* <div className="slider candidates">
                            {mobile() ? 
                            <Slider
                                renderSlider={this.state.renderSlider}
                                setOwlRef={this.setOwlRef}>
                                {this.renderMiflagot()}
                            </Slider> : ""}
                        </div> */}
                        <div className="miflagots">
                            <div className="mobile-scroll" >
                                {/* {this.renderMiflagot()} */}
                            </div>                           
                        </div>
                    </div>
                    {Object.keys(this.props.currentParty).length !==  0 ?
                    <div className="disclaimer-text">{this.props.disclaimerTxt}</div> : ""}
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Miflagot/Miflagot.jsx